import { render } from "./AiAssistantPage.vue?vue&type=template&id=063cee6e&scoped=true"
import script from "./AiAssistantPage.vue?vue&type=script&lang=js"
export * from "./AiAssistantPage.vue?vue&type=script&lang=js"

import "./AiAssistantPage.vue?vue&type=style&index=0&id=063cee6e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-063cee6e"]])

export default __exports__